import { apiSlice } from './apiSlice';
const RETURNS_URL = '/api/returns';

export const returnsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Customer/guest creates a return request
    createReturnRequest: builder.mutation({
      query: (body) => ({
        url: RETURNS_URL,
        method: 'POST',
        body, // includes: orderNumber, orderEmail, postalCode, name, phone, reason, details
      }),
      invalidatesTags: [{ type: 'ReturnRequest', id: 'LIST' }],
    }),

    // Admin list
    listReturns: builder.query({
      query: () => ({ url: RETURNS_URL }),
      providesTags: (res) =>
        res
          ? [
              ...res.map((rr) => ({ type: 'ReturnRequest', id: rr._id })),
              { type: 'ReturnRequest', id: 'LIST' },
            ]
          : [{ type: 'ReturnRequest', id: 'LIST' }],
    }),

    // Admin: update status
    updateReturnStatus: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `${RETURNS_URL}/${id}/status`,
        method: 'PUT',
        body: patch, // { status, refundAmountApproved?, rmaNumber?, trackingCode?, shippingLabelUrl? }
      }),
      invalidatesTags: (_res, _err, arg) => [
        { type: 'ReturnRequest', id: arg.id },
        { type: 'ReturnRequest', id: 'LIST' },
      ],
    }),

    // Admin: fetch multi-carrier rate options (preview before buying)
    getReturnRates: builder.mutation({
      query: ({ id, carriers = [], service = '' }) => ({
        url: `${RETURNS_URL}/${id}/rates`,
        method: 'POST',
        body: { carriers, service }, // e.g., carriers: ['FedEx','CanadaPost','UPS']
      }),
      invalidatesTags: (_res, _err, arg) => [{ type: 'ReturnRequest', id: arg.id }],
    }),

    // Admin: select a specific rate to lock in on the ReturnRequest
    selectReturnRate: builder.mutation({
      query: ({ id, rateId, carrier, service }) => ({
        url: `${RETURNS_URL}/${id}/rate`,
        method: 'PUT',
        body: { rateId, carrier, service }, // rateId preferred; fallback to carrier/service
      }),
      invalidatesTags: (_res, _err, arg) => [
        { type: 'ReturnRequest', id: arg.id },
        { type: 'ReturnRequest', id: 'LIST' },
      ],
    }),

    // Admin: generate label
    createReturnLabel: builder.mutation({
      query: ({ id, carriers = ['FedEx'], service = '' }) => ({
        url: `${RETURNS_URL}/${id}/label`,
        method: 'POST',
        body: { carriers, service },
      }),
      invalidatesTags: (_res, _err, arg) => [
        { type: 'ReturnRequest', id: arg.id },
        { type: 'ReturnRequest', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useCreateReturnRequestMutation,
  useListReturnsQuery,
  useUpdateReturnStatusMutation,
  useGetReturnRatesMutation,
  useSelectReturnRateMutation,
  useCreateReturnLabelMutation,
} = returnsApiSlice;
